export enum DashboardChartTypes {
  NSD = 'NextSeminarDates',
  TSL = 'TodaySalesByLocation',
  TPP = 'TopProductsLast30Days',
  LPO = 'LastProductionOrders',
  AQS = 'ArticleQuickSearch',
  MSIVS = 'MainStoreInactiveVariantsWithStock',
  SCN = 'Scanner',
  LRC = 'LastReclamations',
  RCF = 'RecipeCardFinder',
  MNS = 'MyNextSetupSteps',
  OSP = 'OpenSetupSteps',
}
